import React, { FC, Fragment } from 'react'

import { getJobsPortalUrl } from 'utils/urls'
import { Text, Button, Spinner } from 'components/ui-kit'
import { SvgIcon } from 'components/icon'
import { ModalDialog } from 'components/modal'
import { User } from 'types/user'

import styles from './WelcomeModalView.module.scss'

interface Props {
  isWelcomeModalOpen: boolean
  isApplicant: boolean
  isPending: boolean
  isAuthenticated: boolean
  portalUrl: string
  handleStartApp: () => void
  user: User
}

export const WelcomeModalView: FC<Props> = ({
  isWelcomeModalOpen,
  isApplicant,
  isPending,
  isAuthenticated,
  portalUrl,
  handleStartApp,
  user,
}) => {
  const firstName = user?.firstName
  const lastName = user?.lastName

  return (
    // @ts-ignore
    <ModalDialog bsPrefix="welcome-modal modal" show={isWelcomeModalOpen} className={styles.welcomeModal}>
      <Fragment>
        <div>
          <Text type="heading-3">Thanks for Your Interest!</Text>
        </div>
        <div>
          <Text type="body-1" className={styles.welcomeText}>
            Working with ESS has many rewarding benefits and we look forward to bringing you onboard as a key part of
            our team!
          </Text>
        </div>
        <div className={styles.benefitsList}>
          <div className={styles.benefitItem}>
            <div className={styles.benefitIcon}>
              <SvgIcon name="benefit-time" />
            </div>
            <Text type="body-1">
              The application process is easy, and we will guide you through each step based on the position for which
              you are applying. Applications typically take less than 30 minutes total to complete.
            </Text>
          </div>
          <div className={styles.benefitItem}>
            <div className={styles.benefitIcon}>
              <SvgIcon name="benefit-completed" />
            </div>
            <Text type="body-1">
              You do not have to complete all the steps in a single session. As soon as you register an account with us,
              we will save each completed step of your application. You can stop and then resume later.
            </Text>
          </div>
          <div className={styles.benefitItem}>
            <div className={styles.benefitIcon}>
              <SvgIcon name="benefit-considered" />
            </div>
            <Text type="body-1">
              Your application will be considered “In Progress” until you complete all steps required. You will not be
              considered for employment until you complete your application.
            </Text>
          </div>
        </div>
        {/*<Text type="body-1" className={styles.questionText}>*/}
        {/*If you have any questions at any time during this process, please don’t hesitate to email&nbsp;*/}
        {/*<a href="mailto:applications@ess.com">applications@ess.com.</a>*/}
        {/*</Text>*/}
        <div className={styles.modalFooter}>
          <a href={getJobsPortalUrl()} className={styles.goBackLink}>
            <SvgIcon name="go-back-to" />
            <span>Go Back to Jobs Portal</span>
          </a>
          <div>
            <div className={styles.buttonContainer}>
              <a href={portalUrl}>
                <Button type="secondary" size="big">
                  Log In to Your Account
                </Button>
              </a>
              {isAuthenticated && isApplicant && (
                <div className={styles.userName}>
                  {isPending ? (
                    <Spinner width={17} height={17} />
                  ) : (
                    <Fragment>
                      as&nbsp;
                      <b>
                        {firstName} {lastName}
                      </b>
                    </Fragment>
                  )}
                </div>
              )}
            </div>
            <div className={styles.buttonContainer}>
              <Button type="primary" size="big" onClick={handleStartApp}>
                Create New Account
              </Button>
            </div>
          </div>
        </div>
      </Fragment>
    </ModalDialog>
  )
}
